"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (promise, timeout) {
    return new _promise2.default(function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(resolve, reject) {
            var timer, result;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            timer = setTimeout(function () {
                                return reject(new Error("Promise timed out after " + timeout + " ms"));
                            }, timeout);
                            _context.prev = 1;
                            _context.next = 4;
                            return promise;

                        case 4:
                            result = _context.sent;

                            resolve(result);
                            _context.next = 11;
                            break;

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context["catch"](1);

                            reject(_context.t0);

                        case 11:
                            _context.prev = 11;

                            clearTimeout(timer);
                            return _context.finish(11);

                        case 14:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[1, 8, 11, 14]]);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }());
};
//# sourceMappingURL=timeout.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-external-link/lib/cjs/timeout.js
 ** module id = 510
 ** module chunks = 1
 **/